(function () {
/*
 * -----------------------------------------------------------------------------
 * @cam/product-recommendations
 * -----------------------------------------------------------------------------
 * @version 0.0.2
 * @kind component
 * @copyright 2021 Cam Gould & Elkfox Co Pty Ltd - All rights reserved
 * -----------------------------------------------------------------------------
 * Derived from components from @Shopify/dawn - https://github.com/Shopify/dawn
 * Copyright (c) 2021-present Shopify Inc.
 * Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, sell and/or create derivative works of the Software or any part thereof, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
 * The rights granted above may only be exercised to develop themes that integrate or interoperate with Shopify software or services, and, if applicable, to distribute, offer for sale or otherwise make available any such themes via the Shopify Theme Store. All other uses of the Software are strictly prohibited.
 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 * -----------------------------------------------------------------------------
*/ if (customElements.get("product-recommendations") === undefined) {
    class ProductRecommendations extends HTMLElement {
        constructor(){
            super();
            setTimeout(()=>this.fetchProducts(), 5000);
            const handleIntersection = (entries, observer)=>{
                if (!entries[0].isIntersecting) return;
                observer.unobserve(this);
                this.fetchProducts();
            };
            new IntersectionObserver(handleIntersection.bind(this), {
                rootMargin: "0px"
            }).observe(this);
        }
        fetchProducts() {
            fetch(this.dataset.url).then((response)=>response.text()).then((text)=>{
                const html = document.createElement("div");
                html.innerHTML = text;
                const recommendations = html.querySelector("product-recommendations");
                if (recommendations && recommendations.innerHTML.trim().length) this.innerHTML = recommendations.innerHTML;
            }).catch((error)=>{
                console.error(error);
            });
        }
    }
    customElements.define("product-recommendations", ProductRecommendations);
}



})();
